// Type:
export const TYPE_STRING = 0;
export const TYPE_INT = 1;
export const TYPE_FLOAT = 2;
export const TYPE_DATE = 3;
export const TYPE_BOOLEAN = 4;
export const TYPE_CURRENCY = 5;
export const TYPE_PERCENT = 6;

// FMType:
export const TYPE_REGULAR = 0;
export const TYPE_LIST = 1;
export const TYPE_MULTILIST = 2;
